module.exports = "<md-dialog> <md-dialog-content class=\"modal__content\"> <div class=\"md-dialog-content\"> <h3 class=\"modal__header\">{{\"LEAVE.AREYOUSURE\" | translate}}</h3> <p>{{\"LEAVE.UNSAVEDCHANGES\" | translate}}</p> </div> </md-dialog-content> <md-dialog-actions class=\"modal__buttons\"> <md-button ng-click=\"cancelDialog()\">{{\"BUTTON.CANCEL\" | translate}}</md-button> <md-button class=\"md-accent\" ng-click=\"closeDialog()\">{{\"LEAVE.CONTINUE\" | translate}}</md-button> </md-dialog-actions> </md-dialog>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/savebar/savebar.modal.html
// module id = 1422
// module chunks = 28